export const DIFFERENT_PASSWORDS_CODE = '0070020'
export const GENERIC_PASSWORD_RESET_CONFIRMATION_CODE = '0070021'
export const INVALID_RESET_TOKEN_CODE = '0070022'
export const LOW_QUALITY_PASSWORD_CODE = '0070023'
export const PASSWORD_NOT_COMPLIANT_CODE = '0070024'
export const GENERIC_PASSWORD_CHANGE_CODE = '0070030'
export const GENERIC_INVITATION_ERROR_CODE = '0070041'
export const CURRENT_PASSWORD_DOESNT_MATCH_CODE = '0070031'
export const GENERIC_PASSWORD_VALIDATION_ERROR_CODE = '0070190'

// MFA business error codes
export const MFA_LOCAL_LOGIN_REQUIRED = '0070001'
export const MFA_RECOVERY_OTP_REQUIRED = '0070002'
export const MFA_MECHANISM_ALREADY_REGISTERED = '0070003'
export const MFA_INVALID_OTP = '0070004'
export const MFA_INVALID_REGISTRATION = '0070005'
export const MFA_MECHANISM_DISABLED = '0070006'
export const MFA_ENFORCEMENT_ENABLED = '0070007'
export const MFA_PASSWORD_DOESNT_MATCH = '0070191'
export const GENERIC_MFA_ERROR_CODE = 'GENERIC_MFA_ERROR_CODE'

export const WEB_AUTHN_GENERIC_ERROR = 'WEB_AUTHN_GENERIC_ERROR'

export const GENERIC_SERVER_ERROR_CODE = 'GENERIC_SERVER_ERROR'
export const GENERIC_RECOVERY_CODES_ERROR_CODE =
  'GENERIC_RECOVERY_CODES_ERROR_CODE'
